'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTypicalResponseTimeMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isTypicalResponseTimeMessage = exports.isTypicalResponseTimeMessage = (0, _isType.isType)(_messageTypes.TYPICAL_RESPONSE_TIME);